module.exports = __webpack_public_path__ + "static/font-ba329283e8cdec7f15d0db09d00ff1a9.woff";